import { select, put, call } from 'redux-saga/effects';

import desking from '../../libs/showroom'
import { Creators as actions } from '../actions';
import {
    getConfig,
    getHasTaxesIncluded,
    getPaymentOptions,
    getQuote,
    getQuoteId,
    getShowroomQueryParams
} from '../selectors';

/**
 * @param {Object} payload - Data from action
 */
function* changeDesiredPayment(payload) {
    const quoteId = yield select(getQuoteId);
    const { showroomApiUrl, token } = yield select(getConfig);
    const queryParams = yield select(getShowroomQueryParams);

    const quote = yield select(getQuote);
    const hasTaxesIncluded = yield select(getHasTaxesIncluded);
    const paymentOptions = yield select(getPaymentOptions);
    const body = {
        calculationTargetType: payload.targetType,
        calculationTargetValue: parseFloat(payload.value),
        includeTaxes: hasTaxesIncluded,
        transactionToken: paymentOptions.transactionToken,
        saleType: quote.saleType,
        taxPlan: quote.taxPlan,
        vehicleCondition: quote.vehicleCondition,
        purchaseMethod: paymentOptions.purchaseMethod,
        financePlan: paymentOptions.financePlan,
        kmPerYearPlan: paymentOptions.kmPerYearPlan,
        paymentFrequency: paymentOptions.paymentFrequency,
        term: paymentOptions.term,
        cashDown: paymentOptions.cashDown,
        tradeIn: paymentOptions.tradeIn,
        lien: paymentOptions.lien
    };

    try {
        const response = yield call(desking.paymentRoll, showroomApiUrl, token, quoteId, queryParams, body);
        yield put(actions.changePaymentOptions({
            ...response.negociationTransaction
        }));
    } catch (error) {
        yield put(errorActions.handleError(error, 'updateQuote'));
    }
}

export default changeDesiredPayment;
